import TestemunhoIndividual from './TestemunhoIndividual';

function DonaMalvina() {
    return <TestemunhoIndividual testimonialId={1} />;
}

export default DonaMalvina;
